import { render, staticRenderFns } from "./OnlineRecipe.vue?vue&type=template&id=5458f76a&scoped=true"
import script from "./OnlineRecipe.vue?vue&type=script&lang=js"
export * from "./OnlineRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5458f76a",
  null
  
)

export default component.exports